import { TCertificateForm } from './certificate-form.types';

export enum ECertificateDeliveryMethod {
  email = 'email',
  himself = 'none',
}

const CertificateDeliveryMethodDict = {
  email: 'Доставьте получателю по email',
  himself: 'Подарю самостоятельно',
} as const;

export const initialValuesForm: TCertificateForm = {
  deliveryMethod: ECertificateDeliveryMethod.email,
  fromEmail: '',
  message: '',
  toEmail: '',
  deliveryDate: '',
  total: '1000',
  recaptcha: null,
};

export const certificateDeliveryType = [
  {
    value: ECertificateDeliveryMethod.email,
    label: CertificateDeliveryMethodDict.email,
  },
  {
    value: ECertificateDeliveryMethod.himself,
    label: CertificateDeliveryMethodDict.himself,
  },
];
